export const GIFT_TYPES_FILTER = {
  key: 'giftTypes',
  label: 'Gift type',
};

export const CATEGORIES_FILTER = {
  key: 'categories',
  label: 'Categories',
};

export const BRANDS_FILTER = {
  key: 'brands',
  label: 'Brand',
};

export const SORTING = {
  key: 'sort',
  label: 'Sort by',
};

export const COUNTRY_FILTER = {
  key: 'country',
  label: 'Country',
};

export const SEARCH_FILTER_OPTIONS = { id: -100, name: 'search' };
